import { ColumnsType } from "antd/es/table";
import { IImpoundsList } from "../../../../../../../../../types/Impounds";
import { useCallback, useMemo, useState } from "react";
import { Row, Tooltip } from "antd";
import { getFormattedCurrency } from "../../../../../../../../../lib/currencyFormatter";
import { useCreateImpoundDisbursement } from "../../PayeeDisbursements/hooks/useCreateImpoundDisbursement";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { TableActions } from "../components/TableActions";

type TTableColumns = {
  setShouldPayeeDisbUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  contractId: string;
  onDeleteBtnClick: (id: string) => void;
  onOpenBtnClick: (id: string, activeKey: string, value?: boolean) => void;
  reloadData: () => void;
};

export const useGetTableColumns = ({
  setShouldPayeeDisbUpdate,
  contractId,
  onDeleteBtnClick,
  onOpenBtnClick,
  reloadData
}: TTableColumns) => {
  const [isCreateBtnDisabled, setIsCreateBtnDisabled] = useState<boolean>(false);

  const { createImpoundDisbursement } = useCreateImpoundDisbursement({
    setShouldPayeeDisbUpdate,
    setIsDisabled: setIsCreateBtnDisabled,
    contractId
  });

  const onCreateImpoundDisbBtnClick = useCallback(
    (entry: IImpoundsList): void => {
      createImpoundDisbursement(entry);
    },
    [createImpoundDisbursement]
  );

  const tooltipStyle: any = useMemo(
    () => ({
      maxWidth: "300px"
    }),
    []
  );

  const columns: ColumnsType<IImpoundsList> = useMemo(
    () => [
      {
        title: "Imp Account",
        dataIndex: "impoundAccount",
        key: "impoundAccount",
        width: "9%"
      },
      {
        title: "Type",
        dataIndex: "impoundTypeName",
        key: "impoundTypeName",
        width: "28%",
        ellipsis: true
      },
      {
        title: "Payment Amount",
        dataIndex: "amount",
        key: "amount",
        width: "12%",
        align: "right",
        render: (value: number) => getFormattedCurrency(value)
      },
      {
        title: "Payee",
        dataIndex: "payeeName",
        key: "payeeName",
        width: "27%",
        ellipsis: true
      },
      {
        title: "Current Balance",
        dataIndex: "balance",
        key: "balance",
        width: "13%",
        render: (value: number, record: IImpoundsList) => {
          const val: string = getFormattedCurrency(value);

          return (
            <Row className="align-center justify-end">
              {record.showShortageForUsers && (
                <Tooltip
                  placement="top"
                  title="Impound shortage notification is visible for users"
                  overlayClassName="text-sm"
                  overlayStyle={tooltipStyle}
                >
                  <ExclamationCircleOutlined className="warning mr-2" />
                </Tooltip>
              )}
              <span className="balance-val elipsis" title={val}>
                {val}
              </span>
            </Row>
          );
        }
      },
      {
        key: "actions",
        width: "11%",
        align: "right",
        render: (_: any, record: IImpoundsList) => (
          <TableActions
            isCreateBtnDisabled={isCreateBtnDisabled}
            record={record}
            onDeleteBtnClick={onDeleteBtnClick}
            onOpenBtnClick={onOpenBtnClick}
            onCreateImpoundDisbBtnClick={onCreateImpoundDisbBtnClick}
            reloadData={reloadData}
          />
        )
      }
    ],
    [tooltipStyle, isCreateBtnDisabled, onDeleteBtnClick, onOpenBtnClick, onCreateImpoundDisbBtnClick, reloadData]
  );

  return { columns };
};
